const mark = {
  del: {
    parseDOM: [{ tag: 'del' }],
    toDOM: () => ['del', 0]
  }
};

export default mark;
